export default "__VITE_ASSET__qv8RB7gI__"